const ITEMS = [
  "Movement",
  "Academics",
  "Mentorship",
  "Leadership",
  "Trades Intro",
  "Career Talks",
  "Life Skills",
  "Inclusion",
  "Entrepreneurship",
  "Community",
];

export default function ProgramTicker() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="program-ticker"
      className="bg-brand-navy py-6 border-y border-white/10 overflow-hidden"
    >
      <div className="flex gap-10 animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <div key={i} className="flex items-center gap-10 flex-shrink-0">
            <span className="font-display font-black text-3xl md:text-5xl tracking-tight text-white">
              {item}
            </span>
            <span className="w-2.5 h-2.5 rounded-full bg-brand-coral flex-shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
}
